var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayOran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.26795C16.3333 8.03775 16.3333 9.96225 15 10.7321L3 17.6603C1.66667 18.4301 2.44076e-07 17.4678 2.25717e-07 15.9282L6.04806e-08 2.0718C4.2121e-08 0.532197 1.66667 -0.430054 3 0.339747L15 7.26795Z",
    fill: "#ED7850"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayOran);
export default __webpack_public_path__ + "static/media/playOran.bdfec2fb76c83e45f60fc6b48748533f.svg";
export { ForwardRef as ReactComponent };